import { track, TrackingEventName } from '@heidi/analytics/events';

/** Side-by-side model comparison viewed (control = false, treatment = true). */
export function trackNoteComparisonViewed(
  isComparison: boolean,
  sessionId: string | undefined
): void {
  track({
    event_name: TrackingEventName.NoteComparisonViewed,
    props: {
      is_comparison: isComparison,
      session_id: sessionId,
    },
    options: { amplitude: true },
  });
}
